import { CalendarDate } from '@internationalized/date';
import { ReactElement, useContext, useMemo } from 'react';
import { CalendarStateContext } from 'react-aria-components';
import { useTranslation } from 'react-i18next';
import { CalendarHeadingButton } from '../date-picker/calendar.component';
import { CustomCalendarError } from './custom-calendar-error';

export const CalendarButtonDrawer = ({
  lastFetchableDate,
  onPress,
  toogleOpenDrawer,
  isOpenDrawerError,
}: {
  lastFetchableDate: CalendarDate;
  onPress?: () => void;
  toogleOpenDrawer: () => void;
  isOpenDrawerError: boolean;
}): ReactElement => {
  const calendarContext = useContext(CalendarStateContext);
  const { t } = useTranslation();
  const isLastMonth = useMemo(() => {
    if (!calendarContext) {
      return false;
    }
    // TODo fix (Argument of type 'CalendarDate' is not assignable to parameter of type 'AnyCalendarDate'.)
    // @ts-ignore
    return calendarContext.visibleRange.end.compare(lastFetchableDate) >= 0;
  }, [calendarContext, lastFetchableDate]);
  return (
    <>
      {isLastMonth ? (
        <CustomCalendarError
          label={t('searchResults.appointmentTitle')}
          cta={t('searchResults.appointmentText')}
          isOpen={isOpenDrawerError}
          toggleModal={toogleOpenDrawer}
        />
      ) : null}
      <CalendarHeadingButton
        onPress={onPress}
        className={isLastMonth ? 'sr-only' : ''}
        slot={'next'}
      />
    </>
  );
};
